module.exports = __webpack_public_path__ + "img/miniPro_judai_weita.a006cfc6.png";